export const previewFileConstants = {
  PREVIEW_FILE_SHOW: 'PREVIEW_FILE_SHOW',
  PREVIEW_FILE_CLOSE: 'PREVIEW_FILE_CLOSE',
  PREVIEW_FILE_WITH_PAGE_SHOW: 'PREVIEW_FILE_WITH_PAGE_SHOW',
  UPDATE_CURRENT_INDEX: 'PREVIEW_FILE_UPDATE_CURRENT_INDEX',
};
